import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/bytedance/Desktop/gatsby/src/components/BlogLayout/index.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}></th>
          <th parentName="tr" {...{
            "align": null
          }}></th>
          <th parentName="tr" {...{
            "align": null
          }}></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`头部`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`作用`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`分类`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`cache-control`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`设置强缓存`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`缓存`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`expires`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`设置强缓存`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`缓存`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`etag`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`设置协商缓存`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`缓存`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`last-modified`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`设置协商缓存`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`缓存`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`if-none-match`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`用于和etag比对`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`缓存`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`if-modified-since`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`用于和last-modified比对`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`缓存`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`access-control-allow-origin`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`设置允许跨域访问的源`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`cors`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`access-control-allow-methods`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`设置允许跨域访问的方法`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`cors`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`access-control-allow-headers`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`设置允许跨域访问的头`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`cors`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`access-control-allow-credentials`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`设置是否允许跨域携带cookie`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`cors`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`access-control-max-age`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`设置options请求时间间隔`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`cors`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`accept-language`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`客户端期望接收的语言`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`语言`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`content-language`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`服务端返回的语言`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`语言`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`accept-encoding`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`客户端期望接收的编码格式`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`编码`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`content-encoding`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`服务端返回的编码格式`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`编码`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`accept-charset`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`客户端期望接收的字符集`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`字符集`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`accept`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`客户端期望接收的数据类型`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`数据类型`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`content-type`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`服务端返回的数据类型和字符集`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`数据类型,字符集`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`content-length`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`服务端返回的资源大小`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`资源大小`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`transfer-encoding`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`分块传输标志，为0表示传输完毕`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`分块传输`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`host`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`服务器对应的域名`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`其他`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`origin`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`当前请求资源所在页面的协议和域名`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`其他`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`referer`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`当前请求资源所在页面的完整路径，可带查询参数，但不带hash`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`其他`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`user-agent`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`客户端信息`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`其他`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      